import { useLocation, useNavigate } from "react-router-dom";
import {
  getSelectedTabListView,
  getUserData,
  setSelectedSearchOrderType,
  setSelectedTabListView,
} from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "../../SchedularModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import StoreMenu from "../../StoreMenu";
import ButtonLink from "../../../ButtonLink";
import useLoyaltyPointLog from "../../StoreContext/useLoyaltyPointLog";
import {
  getCustomerLoyaltyPointLog,
  postStoreCustomerLoyaltyPoints,
} from "../../../services/LoyaltyPoint/LoyaltyPoint";
import AdminMenu from "../../AdminMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SuccessModal from "../../SuccessModal";

const { innerWidth: width, innerHeight: height } = window;

const CustomerLoyaltyPointPointLog = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { storeCustomerId, loyaltyPoint, storeIdValue } = location.state || {};
  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const userRole = userProfileRole;

  const storeId = userRole === "BY_STORE" ? storeData.id : storeIdValue;
  let brandId = brandProfileData.id;
  const {
    sortingData,
    setSortingData,
    schedularDate,
    setSchedularDate,
    loyaltyPointLogData,
    setLoyaltyPointLogData,
    loyaltyPointPointLogData,
    setLoyaltyPointPointLogData,
    page,
    setPage,
    useEffectCall,
    setUseEffectCall,
  } = useLoyaltyPointLog();

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [visible, setVisible] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");


  const initializeVariable = () => {
    // setLoyaltyPointLogData([]);
    setLoyaltyPointPointLogData([]);
  };

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleSortData = () => {
    setUseEffectCall(true);
    setPage(0);
    setSortingData(!sortingData);
  };

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListView();
      setTabularView(selectedInvoiceTypeData?.tabListView || "list");
    } catch {
      setTabularView("list");
    }
  };

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchPackageLogData = (data) => {
    setLoading(true);
    getCustomerLoyaltyPointLog({
      ...data,
      limit: 20,
      offset: page * 20, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (page === 0) {
            // setLoyaltyPointLogData(Res); // Reset with fresh data
            setLoyaltyPointPointLogData(Res)
          } else {
            // setLoyaltyPointLogData((prevData) => {
            //   const existingIds = new Set(prevData.map((item) => item.id));
            //   const newUniqueData = Res.filter(
            //     (item) => !existingIds.has(item.id)
            //   );
            //   return [...prevData, ...newUniqueData];
            // });
            setLoyaltyPointPointLogData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter(
                (item) => !existingIds.has(item.id)
              );
              return [...prevData, ...newUniqueData];
            });
          }
          setLoading(false);
          setLoadingSearch(false);
          setIsEndReached(Res.length < 20);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [storeId],
    brandId: brandId,
    // startDate:startDate,
    // endDate:endDate,
    sortOrder: "desc",
    sortBy: "id",
    storeCustomerId: storeCustomerId,
    conversionType: "POINT",
  };
  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      requestData.sortOrder = sortingData ? "asc" : "desc";
      setPage(0);
      fetchPackageLogData(requestData);
    }
  }, [schedularDate, sortingData]);

  useEffect(() => {
    fetchPackageLogData(data);
    fetchSelectedTabListView();

  }, []);

  const handleCalculateLoyaltyPoints = () => {

    const LPData = {
      brandId: brandId,
      storeId: storeId,
      storeCustomerId: storeCustomerId
    }
    postStoreCustomerLoyaltyPoints(LPData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;

            if (status === true && message === "success") {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
              setTimeout(() => {
                navigate("/Customer-Loyalty-Point-Log", {
                  state: {
                    storeCustomerId: storeCustomerId,
                    loyaltyPoint: loyaltyPoint,
                    storeId: storeId,
                  },
                })
              }, 2000);
            } else {
              setModalVisible(true);
              setModalStatus("failed");
              setModalText(message);
            }
            
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  useEffect(() => {
    if (page > 0) fetchPackageLogData(requestData);
  }, [page]);

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };

  const itemTemplate = (data) => {
    const formattedCreatedDate = formatDate(data.createdDate);
    const index = loyaltyPointPointLogData.findIndex(
      item => item === data
    );
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": "#",
              fontSize: 10,
            }}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={data.id} // Use a more unique key like data.id
          header={`${formattedCreatedDate} -> Conversion Unit : ${data.conversionUnit
            } | ${data?.conversionType === "POINT"
              ? "Loyalty Point Awarded"
              : "Discount"
            } : ${data.conversion} | ${data.invoiceNo || " "}`}
          style={{
            "--backgroundColor-AccordionTab": "#3EB3E1",
          }}
        >
          <div
            className="cursor-pointer"
            onClick={() =>
              navigate("/OrdersGarmentInfo", {
                state: {
                  bookingOrderId: data.orderId,
                  storeCustomerId: data.storeCustomer.id,
                  navigateThrough: "GoBack",
                },
              })
            }
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Conversion Type:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionType}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Create On:</p>
                <p className="text-lg font-bold capitalize">
                  {formatDate(data?.createdDate)}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Conversion Unit:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionUnit}
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  {data?.conversionType === "POINT"
                    ? "Bill Amount"
                    : "Point Converted"}{" "}
                  :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionTo}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  {data?.conversionType === "POINT"
                    ? "Loyalty Point Awarded"
                    : "Discount"}{" "}
                  :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversion}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice No:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.invoiceNo || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
        onClick={() =>

          navigate("/OrdersGarmentInfo", {
            state: {
              bookingOrderId: rowData.orderId,
              storeCustomerId: rowData.storeCustomer.id,
              navigateThrough: "GoBack",
            },
          })

        }
      >
        <span style={{ color: "blue", textDecoration: "underline" }}>
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };


  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={loyaltyPointPointLogData}
        // header={header}
        paginator
        rows={50}
        rowsPerPageOptions={[50, 75, 100]}
        // tableStyle={{ minWidth: "120rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 160}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        ></Column>

        <Column
          field="conversionType"
          header="Conversion Type"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.conversionType}
        ></Column>

        <Column
          field="Date"
          header="Create On"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => formatDate(rowData?.createdDate)}
        ></Column>


        <Column
          field="conversionUnit"
          header="Conversion Unit"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.conversionUnit}
        ></Column>

        <Column
          field="conversionTo"
          header="Conversion To"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.conversionTo}
        ></Column>

        <Column
          field="conversion"
          header="Conversion"
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.conversion}
        ></Column>


      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/Customer-Loyalty-Point-Log", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        loyaltyPoint: loyaltyPoint,
                        storeId: storeId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Loyalty Point Awarded Log
              </p>
            </div>
          </div>
          {
            userRole === "BY_ADMIN" &&
            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => {
                handleCalculateLoyaltyPoints()
              }}
            >
              <div
                className="px-3 py-1 cursor-pointer"
                style={{
                  backgroundColor: "#bdac55",
                  borderRadius: 5,
                  marginRight: 20,
                }}
              >
                <p className=" text-lg text-white font-medium capitalize">
                  Re-Calculate Loyalty Points
                </p>
              </div>
            </div>
          }
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            )}
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
        <div className="flex justify-content-center">
          <h3>Loyalty Point : {loyaltyPoint}</h3>
        </div>
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : loyaltyPointPointLogData?.length > 0 ? (

          <div>
            <div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                >
                  <div className="report-table ml-2 mr-2">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: tabularView === "tab" ? "none" : "" }}>
              <DataScroller
                value={loyaltyPointPointLogData}
                itemTemplate={itemTemplate}
                rows={loyaltyPointPointLogData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 100}
                loader
              // footer={footer}
              />
            </div>
          </div>

        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Loyalty Point Found</p>
          </div>
        )}
        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 10, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>
        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
        {userRole === "BY_STORE" ? (
          <StoreMenu setVisible={setVisible} visible={visible} />
        ) : (
          <AdminMenu setVisible={setVisible} visible={visible} />
        )}
        <ButtonLink />
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default CustomerLoyaltyPointPointLog;
